import { Container, Typography, Grid, Paper, Box } from "@mui/material";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import PeopleIcon from "@mui/icons-material/People";
import CasinoIcon from "@mui/icons-material/Casino";
const steps = [
  {
    icon: <CasinoIcon sx={{ fontSize: 48 }} />,
    title: "Δημιουργία Λοταρίας",
    description:
      "Ρύθμισε τη χριστουγεννιάτικη λοταρία σου με ένα γιορτινό όνομα, ημερομηνία και πρόσθεσε συμμετέχοντες.",
  },
  {
    icon: <CardGiftcardIcon sx={{ fontSize: 48 }} />,
    title: "Πρόσθεσε Έπαθλα",
    description:
      "Πρόσθεσε συναρπαστικά έπαθλα που οι τυχεροί νικητές μπορούν να κερδίσουν κατά τη διάρκεια της κλήρωσης.",
  },
  {
    icon: <PeopleIcon sx={{ fontSize: 48 }} />,
    title: "Πρόσθεσε Συμμετέχοντες",
    description:
      "Πρόσθεσε όλους τους ανθρώπους που θα συμμετάσχουν στη χριστουγεννιάτικη λοταρία σου.",
  },
  {
    icon: <PlayCircleIcon sx={{ fontSize: 48 }} />,
    title: "Κάνε την Κλήρωση",
    description:
      "Όταν είσαι έτοιμος, διενέργησε τη λοταρία και παρακολούθησε τη μαγική κλήρωση να ξεδιπλώνεται!",
  },
];

export const HowItWorks = () => {
  return (
    <Container maxWidth="lg" sx={{ py: { xs: 6, md: 10 } }}>
      <Typography
        variant="h2"
        sx={{
          fontFamily: '"Mountains of Christmas", cursive',
          color: "hsl(150, 60%, 25%)",
          textAlign: "center",
          mb: 6,
          fontSize: { xs: "2rem", md: "3rem" },
        }}
      >
        Πώς Λειτουργεί
      </Typography>
      <Grid container spacing={4}>
        {steps.map((step, index) => (
          <Grid size={{ xs: 12, sm: 6, md: 3 }} key={index} paddingBottom={12}>
            <Paper
              elevation={0}
              sx={{
                p: 4,
                textAlign: "center",
                height: "100%",
                bgcolor: "white",
                borderRadius: 4,
                border: "2px solid hsl(30, 20%, 85%)",
                transition: "all 0.3s",
                "&:hover": {
                  transform: "translateY(-8px)",
                  boxShadow: "0 12px 40px -12px rgba(0,0,0,0.15)",
                  borderColor: "hsl(350, 80%, 40%)",
                },
              }}
            >
              <Box
                sx={{
                  width: 80,
                  height: 80,
                  borderRadius: "50%",
                  bgcolor: "hsl(350, 80%, 40%)",
                  color: "white",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mx: "auto",
                  mb: 3,
                }}
              >
                {step.icon}
              </Box>
              <Typography
                variant="h5"
                sx={{
                  fontFamily: '"Mountains of Christmas", cursive',
                  color: "hsl(150, 60%, 25%)",
                  mb: 2,
                }}
              >
                {step.title}
              </Typography>
              <Typography sx={{ color: "hsl(150, 20%, 35%)" }}>
                {step.description}
              </Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};
